module.exports = __webpack_public_path__ + "static/media/search.d406a1d7.svg";